export enum AccessPointProcessingStep {
  CMSAcceptingNewPatientsTransform,
  CMSAcceptingNewPatientsValidate,
  CMSCertificationNumberValidate,
  CMSContractAmendmentValidate,
  CMSContractTypeValidate,
  CMSGroupAffiliationDownstreamContractValidate,
  CMSGroupAffiliationDirectContractValidate,
  CMSHospitalServiceLinesAppend,
  CMSHospitalServiceLinesValidate,
  CMSIllegalCharacterValidate,
  CMSIllegalCharacterTransform,
  CMSSpecialtyCodeFacilityValidate,
  CMSSpecialtyCodeNPorPAValidate,
  CMSSpecialtyCodePCPValidate,
  CMSSpecialtyCodeProviderValidate,
  FacilitiesByTaxIdAndType2Query,
  GeocodeTransform,
  ServiceLocationUrlFormatValidate,
  ServiceLocationUrlNotBlankValidate,
  TaxIdNineDigitsValidate,
  TaxIdNotBlankValidate,
  TaxIdNumericValidate,
  TaxIdRemoveDashesTransform,
  TaxIdType1NPIsByLatLongQuery,
  TaxIdType1NPIsByTaxIdQuery,
  TaxonomyCodeValidate,
  TaxonomyNotBlankValidate,
}
